import React from 'react';
import './ProductMedia.css';

export function isVideoMedia(source, mediaType = '') {
    if (String(mediaType || '').toLowerCase().startsWith('video/')) {
        return true;
    }

    const cleanSource = String(source || '').split('?')[0].split('#')[0].toLowerCase();
    return /\.(mp4|webm|ogg|ogv|mov)$/i.test(cleanSource);
}

export function getProductMediaSources(item = {}) {
    return Array.from({ length: 10 }, (_, index) => item[`imagen${index + 1}`]).filter(Boolean);
}

export function getProductImageSources(item = {}) {
    return getProductMediaSources(item).filter((source) => !isVideoMedia(source));
}

export function getFirstProductMedia(item = {}) {
    return getProductMediaSources(item)[0] || null;
}

export function getFirstProductImage(item = {}) {
    return getProductImageSources(item)[0] || null;
}

export default function ProductMedia({
    src,
    alt = '',
    mediaType = '',
    className = '',
    onClick,
    controls = false,
    autoPlay = false,
    muted = true,
    loop = false,
}) {
    if (!src) {
        return null;
    }

    if (isVideoMedia(src, mediaType)) {
        return (
            <video
                src={src}
                className={className}
                onClick={onClick}
                controls={controls}
                autoPlay={autoPlay}
                muted={muted}
                loop={loop}
                playsInline
                preload="metadata"
            />
        );
    }

    return <img src={src} alt={alt} className={className} onClick={onClick} />;
}
